<style lang="scss" scoped>
.forceLogin {
	margin: 0 auto;
	text-align: center;
}
</style>

<template lang="pug">
.forceLogin
		el-button(type="primary", :loading="loading") Please wait while we connect you to PLATFORM V3
</template>

<script>
import gql from "graphql-tag";
import { onLogin } from "@/vue-apollo";

const AUTH_TOKEN = "wonde-auth-token";
export default {
	name: "ForceLogin",
	data: () => ({
		loading: false,
	}),
	watch: {
		async '$route.query.key'() {
			await this.forceLogin();
		}
	},
	async mounted() {
        await this.forceLogin();
    },
	methods: {
		async forceLogin() {
			const key = this.$route.query.key === undefined ? "" : decodeURI(this.$route.query.key.replaceAll(" ", "+"))
			try {
				const result = await this.$apollo.query({
					client: "public",
					query: gql`
						query Signin($key: String!) {
							Signin(key: $key)
						}
					`,
					variables: {
						key: key
					}
				});

				const signedPayload = JSON.parse(result.data.Signin);

				if (signedPayload.token && signedPayload.token.length > 0 ) {
					this.loading = true;
					try {
						await onLogin(signedPayload.token);
						this.$router.push({
							name: "schools"
						});
					} catch (error) {
						this.$router.push({
							name: "auth.login"
						});
					}
				} else {
				    this.$router.push({
				        name: "auth.login"
				    });
				}

			} catch (error) {
				if (error.message) {
					this.$message.error("Signin failed. Please try again");
				}
				this.$router.push({
					name: "auth.login"
				});
			}
		}
	}
};
</script>
